import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const F2Icon = ({ viewBox = '0 0 16 16', ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox={viewBox} {...props}>
      <rect width="16" height="16" rx="4" fill="black" fillOpacity="0.13" />
      <path
        d="M4.22949 11.5H2.95117V3.64746H7.3877V4.73242H4.22949V7.18164H7.18359V8.26123H4.22949V11.5ZM13.5967 11.5H8.2793V10.5493L10.3149 8.48682C10.7088 8.08577 11.0329 7.74023 11.2871 7.4502C11.5413 7.15658 11.7293 6.87907 11.8511 6.61768C11.9764 6.35628 12.0391 6.07161 12.0391 5.76367C12.0391 5.38411 11.9299 5.09766 11.7114 4.9043C11.493 4.70736 11.2048 4.60889 10.8467 4.60889C10.5065 4.60889 10.1914 4.67692 9.90137 4.81299C9.61491 4.94548 9.31771 5.13525 9.00977 5.38232L8.31689 4.5498C8.53532 4.36361 8.76807 4.19352 9.01514 4.03955C9.26579 3.88558 9.54508 3.76383 9.85303 3.67432C10.161 3.58122 10.5119 3.53467 10.9058 3.53467C11.4035 3.53467 11.8332 3.62419 12.1948 3.80322C12.5565 3.97868 12.834 4.22396 13.0273 4.53906C13.2243 4.85417 13.3228 5.22119 13.3228 5.64014C13.3228 6.06266 13.2386 6.45296 13.0703 6.81104C12.902 7.16911 12.6621 7.5236 12.3506 7.87451C12.0391 8.22184 11.6685 8.59961 11.2388 9.00781L9.87988 10.3345V10.3936H13.5967V11.5Z"
        fill="#2C2E33"
      />
    </SvgIcon>
  );
};

export default F2Icon;
